var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.list
    ? _c(
        "w-card",
        [
          _c(
            "w-card-title",
            [
              _vm._v(" Active Users "),
              _c("w-spacer"),
              _vm._v(" " + _vm._s(_vm.list.getUsers().length) + " "),
            ],
            1
          ),
          _vm.list.getUsers().length == 0
            ? _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(" No active users "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-scroll-view",
                {
                  staticClass: "user-list",
                  attrs: { tag: "w-list" },
                  nativeOn: {
                    scroll: function ($event) {
                      return _vm.onScroll($event)
                    },
                  },
                },
                _vm._l(_vm.list.getUsers(), function (user) {
                  return _c(
                    "w-list-item",
                    { key: user.id },
                    [
                      _c("w-list-item-text", {
                        directives: [
                          {
                            name: "safe-html",
                            rawName: "v-safe-html",
                            value: user.toString(),
                            expression: "user.toString()",
                          },
                        ],
                      }),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.getSessionInfo(user)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "info" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.openUserCompany(user)
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: { icon: "external-link-alt" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
          _c(
            "w-modal",
            {
              attrs: { value: _vm.openedSessionInfoUser != null },
              on: {
                input: function ($event) {
                  return _vm.closeSessionInfo()
                },
              },
            },
            [
              _vm.openedSessionInfoUser
                ? _c("app-active-user-list-session-info", {
                    attrs: {
                      user: _vm.openedSessionInfoUser,
                      info: _vm.openedSessionInfo,
                    },
                    on: { close: _vm.closeSessionInfo },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }